<template>
<div
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]">
  <div
    class="input-field col s12"
    :ref="name"
  >
  <div class="custom-label">
    <span v-html="label"></span>
  </div>
    <textarea
      :id="`${name}`"
      class="materialize-textarea"
      v-model="fieldValue"
      :class="[fieldStyle.class]"
      :style="[fieldStyle.style]"
      :disabled="isDisabled"
      :autocomplete="autoComplete ? 'on' : 'off'"
    />
  </div>
</div>
</template>

<script>
export default {
  name: 'CustomConditionField',
  props: {
    value: {
      type: [String, Number],
    },
    name: {
      type: String,
      required: true,
    },
    targetValue: {
      type: String,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
    },
    dataConditions:{
      type: [Array, String, Boolean],
      default:false,
    },
    fieldType: {
      type: String,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    showHelperText: {
      type: Boolean,
      default: () => true,
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    // isDisabled: {
    //   type: Boolean,
    //   default: false,
    //   reuqired: false,
    // },
  },
  data() {
    return {
      fieldValue: this.value,
    };
  },
  mounted() {},
  watch: {
    fieldValue: function() {
      // this.allowOnlyNumber();
      this.updateValue();
    },
  },
  computed: {
    isDisabled() {
      if (this.dataConditions) {
        if (this.dataConditions.includes(this.targetValue)) {
          return false;
        }  
      }
      return true;
    },
  },
  methods: {
    updateValue() {
      // console.log(error, hasError);
      this.$emit("update", this.fieldValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.negative-margins {
    margin: -24px -24px 0;
    display: flow-root;
    padding: 14px; 
      @media screen and (min-width: 1024px) {
        margin: 0px 0px 24px;
        width: 100%;
        border-radius: 8px;
    }
}
 .custom-label {
  font-size: 17px;
  line-height: 22px;
  margin-bottom: 6px;
 }   
</style>
